export const spanish = {
  back: 'Volver',
  case_no: 'N\xFAmero de caso',
  chart_view: 'Gr\xE1fico',
  click_to_crime: 'Clic a cr\xEDmen en mapa',
  city_block: 'un bloque (110 yardas)',
  couple_blocks: 'un par de bloques (1/8 milla)',
  quarter_mile: 'un cuarto de milla',
  half_mile: 'una media milla',
  mile: 'una milla',
  crime: 'Crimen',
  crimes: 'Cr\xEDmenes',
  crimes_by_address_filename: 'crimenes_alrededor_de_la_direccion.csv',
  crimes_by_street_filename: 'crimenes_por_la_calle.csv',
  crimes_by_neighborhood_filename: 'crimenes_en_el_barrio.csv',
  crime_pie_chart: 'Gr\xE1fico circular de cr\xEDmenes',
  date: 'Fecha',
  during: 'durante',
  last_30_days: 'los \xFAltimos 30 d\xEDas',
  last_6_months: 'los \xFAltimos 6 meses',
  last_year: 'el \xFAltimo a\xF1o',
  last_5_years: 'los \xFAltimos 5 a\xF1os',
  all_time: 'todo el tiempo',
  law_beat: 'Ronda',
  list_view: 'Lista',
  location: 'Lugar',
  map_view: 'Mapa',
  no_results_found: 'No se han encontrado resultados',
  placeholder: 'Buscar...',
  type: 'Tipo',
  view: 'ver',
  view_apd_reports: 'Ver informes del APD',
  within: 'dentro de',
};
